module.exports = __webpack_public_path__ + "img/z.d7a60525.png";